export default __webpack_public_path__ + "static/media/item_location_changed.1f5bbb41.svg";